import(/* webpackMode: "eager", webpackExports: ["CouponsWebPage"] */ "/opt/buildhome/repo/src/app/[lng]/(main)/_account-web/personal-web.tsx");
